export default "__VITE_ASSET__kJ6sZ0S8__"